import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  const backdropBlur = useTransform(scrollY, [0, 100], [0, 24]);
  const backgroundColor = useTransform(scrollY, [0, 100], ['rgba(5, 10, 20, 0)', 'rgba(5, 10, 20, 0.95)']);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const links = [{
    label: 'Hoe het werkt',
    href: '#hoe'
  }, {
    label: 'Voor wie',
    href: '#voor-wie'
  }, {
    label: 'Bewijs',
    href: '#bewijs'
  }];
  return <motion.nav style={{
    backgroundColor,
    backdropFilter: `blur(${backdropBlur}px)`
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'border-b border-white/5 shadow-glass' : ''}`} data-id="element-303">
      <div className="max-w-[1200px] mx-auto px-6 h-20 flex items-center justify-between" data-id="element-304">
        <motion.a href="#" className="focus:outline-none" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-305">
          <Logo data-id="element-306" />
        </motion.a>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-10" data-id="element-307">
          {links.map((link, i) => <motion.a key={link.href} href={link.href} className="relative text-[0.95rem] font-semibold text-white/70 hover:text-white transition-colors group" initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1,
          type: 'spring',
          stiffness: 100
        }} data-id="element-308">
              {link.label}
              <motion.span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-brand-arctic rounded-full" initial={{
            scaleX: 0
          }} whileHover={{
            scaleX: 1
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20
          }} data-id="element-309" />
            </motion.a>)}
          <motion.a href="#gesprek" className="magnetic-btn inline-flex items-center gap-2 bg-brand-primary text-white font-bold text-[0.95rem] px-6 py-3 rounded-2xl transition-all duration-500" whileHover={{
          scale: 1.05,
          boxShadow: '0 8px 32px rgba(0, 102, 255, 0.4)'
        }} whileTap={{
          scale: 0.95
        }} initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          type: 'spring',
          stiffness: 100
        }} data-id="element-310">
            <motion.span className="w-1.5 h-1.5 rounded-full bg-white" animate={{
            boxShadow: ['0 0 0 0 rgba(255, 255, 255, 0.7)', '0 0 0 8px rgba(255, 255, 255, 0)']
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} data-id="element-311" />
            Plan een gesprek
          </motion.a>
        </div>

        <motion.button className="md:hidden p-2 text-white" onClick={() => setIsOpen(!isOpen)} whileTap={{
        scale: 0.9
      }} data-id="element-312">
          {isOpen ? <XIcon size={24} data-id="element-313" /> : <MenuIcon size={24} data-id="element-314" />}
        </motion.button>
      </div>

      <AnimatePresence data-id="element-315">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="md:hidden bg-[#050A14]/98 backdrop-blur-2xl border-b border-white/5" data-id="element-316">
            <div className="flex flex-col px-6 py-6 gap-5" data-id="element-317">
              {links.map((link, i) => <motion.a key={link.label} href={link.href} className="text-white/80 font-semibold text-lg hover:text-white transition-colors" onClick={() => setIsOpen(false)} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1
          }} data-id="element-318">
                  {link.label}
                </motion.a>)}
              <motion.a href="#gesprek" className="btn-primary w-full justify-center" onClick={() => setIsOpen(false)} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.3
          }} whileTap={{
            scale: 0.95
          }} data-id="element-319">
                Plan een gesprek
              </motion.a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}